export default __webpack_public_path__ + "assets/images/0cd965001644b56bcb7bf2ac406aca6f.png";